import { type FC } from "react";
import { Button, Modal } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import "./ConfirmationModal.less";

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  description: string;
  cancelText: string;
  confirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
  confirmDanger?: boolean;
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
  open,
  title,
  description,
  cancelText,
  confirmText,
  onCancel,
  onConfirm,
  confirmDanger = false,
}) => {
  return (
    <Modal
      open={open}
      title={
        <span className="confirmation-modal__title">
          <CheckCircleFilled className="confirmation-modal__title-icon" />
          {title}
        </span>
      }
      onCancel={onCancel}
      width={420}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {cancelText}
        </Button>,
        <Button
          key="confirm"
          type="primary"
          danger={confirmDanger}
          className={confirmDanger ? "" : "confirmation-modal__confirm-btn"}
          onClick={onConfirm}
        >
          {confirmText}
        </Button>,
      ]}
    >
      <p className="confirmation-modal__description">{description}</p>
    </Modal>
  );
};

export default ConfirmationModal;
